import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["testType"]

  changeTestType(event) {
    const testType = event.target.value
    const url = new URL(window.location.href)
    url.searchParams.set("test_type", testType)
    window.Turbo.visit(url.toString())
  }
}
